import React from 'react';
import styled from 'styled-components/macro';

import { CompanyOption } from '../routes/error';

import Toolbar from 'components/Toolbar';
import Dropdown from 'components/Input/dropdown/Dropdown';
import { RangeDate } from '../routes/dashboard';
import DateFilters from './DateFilters';

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  text-align: right;
  padding-left: 20px;
  padding-right: 25px;
`;

const HeaderContainerLeft = styled.div`
  align-items: center;
  display: flex;
`;

const HeaderContainerRight = styled.div`
  align-items: center;
  display: flex;
`;

const CompanyWrapper = styled.div`
  text-align: left;
  width: 200px;
`;

const ChildrenWrapper = styled.div``;

interface HeaderProps {
  date?: Date;
  setDate?: (date: Date) => void;
  rangeDateActive?: boolean;
  setRangeDateActive?: (checkRangeDate: boolean) => void;
  rangeDate?: RangeDate;
  setRangeDate?: (rangeDate: RangeDate) => void;
  children?: any;
  companies?: CompanyOption[];
  companySelection?: boolean;
  setSelectedCompany?: ({ label, value }: CompanyOption) => void;
  selectedCompany?: CompanyOption | null;
}

const Header = (props: HeaderProps) => {
  const {
    setDate,
    date,
    rangeDateActive,
    setRangeDateActive,
    rangeDate,
    setRangeDate,
    companySelection,
    setSelectedCompany,
    selectedCompany,
    companies,
    children,
  } = props;

  return (
    <Toolbar.ActionBar>
      <HeaderWrapper>
        <HeaderContainerLeft>
          {companySelection && companies ? (
            <CompanyWrapper>
              <Dropdown
                id="company-dropdown"
                value={selectedCompany}
                onChange={(option) => setSelectedCompany && setSelectedCompany(option)}
                options={companies}
              />
            </CompanyWrapper>
          ) : null}
          {children ? <ChildrenWrapper>{children}</ChildrenWrapper> : null}
        </HeaderContainerLeft>
        <HeaderContainerRight>
          {!companySelection ? (
            <DateFilters
              date={date}
              setDate={setDate}
              rangeDateActive={rangeDateActive}
              setRangeDateActive={setRangeDateActive}
              rangeDate={rangeDate}
              setRangeDate={setRangeDate}
            />
          ) : null}
        </HeaderContainerRight>
      </HeaderWrapper>
    </Toolbar.ActionBar>
  );
};

export default Header;
